import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
// Vendor Components
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
// Custom Components
import { TextFieldAdapter } from '../Form/TextFieldAdapter';
import { FormIcon } from '../Form/FormIcon';
import AuthStepper from '../Stepper/AuthStepper';
import Snackbar from 'material-ui/Snackbar';

// Steps
import LoginStep from '../Form/Steps/LoginStep';
import SignUpStep from '../Form/Steps/SignUpStep';
import PaymentStep from '../Form/Steps/PaymentStep';
import VerificationStep from '../Form/Steps/VerificationStep';
import ConfirmStep from '../Form/Steps/ConfirmStep';
import PasswordResetStep from '../Form/Steps/PasswordResetStep';

// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../Form/validation';

let _submitting;
let _pristine;

class ActivationDialog extends Component {
    
    state = {
        errors: {
            code: '',
            message: ''
        },
        finalStep: null,
        snackAutoHideDuration: 4000,
        snackMessage: '',
        snackOpen: false,
        stepToShow: 0,
    };

    handleLogin = values => {
        this.props.startLogin('password', values.email, values.password)
            .then((user) => {
                // console.log('User logged in:', user);
                this.handleCloseDialog();
                // this.resetErrors(reset); // reset is undefined
            })
            .catch((error)=>{
                return { [FORM_ERROR]: "Login Failed" };
            });
    }

    handleSignUp = async (values) => {
        if (values.password === values.passwordConfirmation) {
            let response = await this.props.startSignUp(values.email, values.password)    
                .then((user) => {
                    this.advanceStepper();
                })
                .catch((error)=>{
                    return { [FORM_ERROR]: "Passwords must match." };
                });
        }
    }

    setFormStates = (submitting, pristine) => {
        _submitting = submitting;
        _pristine = pristine;
    }

    handleChooseAuthDialog = (choice) => {
        this.setState({
            currentDialog: choice
        });
        this.props.setCurrentDialog(choice);
        // console.log('called set current dialog...');
    }

    componentWillReceiveProps(nextProps) {
        // console.log('%cSERVER ERROR @ CWRP:','color: gold');
        // console.log(nextProps.errorData);
        if (this.props.errorData !== nextProps.errorData){
            // console.log('changing error state from', this.state.errors);
            this.setState({
                errors: nextProps.errorData
            }, ()=>{
                // console.log('%cNEW ERROR STATE IS:','color: greenyellow');
                // console.log(this.state.errors);
            })
        }
        if ((this.props.emailIsVerified !== nextProps.emailIsVerified) && !!nextProps.emailIsVerified) {
            // console.log('EMAIL HAS BEEN VERIFIED NOW CHANGING TO NEXT SCREEN', nextProps.emailVerified);
            
            this.props.notifyUser({
                message: 'Congratulations, your account has been successfully activated!',
                textColor: 'white',
                visible: true,
            })    
            .then((res) => {
                this.handleCloseDialog();
            })
            .catch(console.log);
        }

        if ((nextProps.userId !== this.props.userId && !!nextProps.userId && nextProps.emailVerified) || (nextProps.emailVerified && this.props.emailVerified !== nextProps.emailVerified)) {
            
            this.props.notifyUser({
                message: 'Welcome, you are now logged in.',
                textColor: 'white'
            })    
            .then((res) => {
                if(nextProps.emailIsVerified){
                    this.props.handleClose();
                }
            })
            .catch(console.log);
        }
    }
    
    advanceStepper = () => {
        // console.log('Prev Step:', this.state.stepToShow);
        const currentStep = this.state.stepToShow;
        this.setState({
            stepToShow: currentStep + 1
        }, ()=>{
            // console.log('New Step:', this.state.stepToShow);
        })
    }

    reverseStepper = () => {
        const currentStep = this.state.stepToShow;
        if (currentStep > 0) {
            this.setState({
                stepToShow: currentStep - 1
            });
        }
    }

    resetStepper = () => {
        this.setState({
            stepToShow: 0
        })
    }

    stepperControls = {
        advanceStepper: this.advanceStepper,
        reverseStepper: this.reverseStepper,
        setFinalStep: this.setFinalStep,
    }
    
    handleCloseDialog = () => {
        // console.log('%cCLOSING DIALOG...','color: gold');
        this.props.handleClose();
        // this.resetDialog();
        // this.determineAuthFlowRequirement();
    }

    // BUTTONS

    getActionButton = ({label= "Next", form= null, primary= true, secondary= false, isNextButton= true, action= () => { return null }, raised = true, disabled=false}) => {
        const isForm = !!form;
        const formType = (isForm) ? "submit" : "button";
        return (raised) 
        ?   <RaisedButton
                label={label}
                type={formType}
                onSubmit={(event)=>{ 
                    event.preventDefault();
                }}
                onClick={(event)=>{
                    action(event);
                    if (isNextButton && !!this.props.userId) this.advanceStepper();
                }}
                form={form}
                disableTouchRipple={true}
                disableFocusRipple={true}
                primary={primary}
                secondary={secondary}
                style={{marginRight: 12}}
                disabled={disabled}
            />
        :   <FlatButton
                label={label}
                type={formType}
                onSubmit={(event)=>{ 
                    event.preventDefault();
                }}
                onClick={(event)=>{
                    if (isNextButton) this.advanceStepper();
                    action(event);
                }}
                form={form}
                disableTouchRipple={true}
                disableFocusRipple={true}
                primary={primary}
                secondary={secondary}
                style={{marginRight: 12}}
                disabled={disabled}
            />;
    }

    getCancelButton = (handleClose, reset) => {
        return (
            <FlatButton
                label="Cancel"
                disableTouchRipple={true}
                disableFocusRipple={true}
                onClick={(event)=>{
                    handleClose();
                    // this.props.resetErrors();
                    this.resetErrors(reset)
                    this.resetStepper();
                }}
                style={{marginRight: 12}}
            />
        );
    }

    // getBackButton = () => {
    //     return (
    //         <FlatButton
    //             label="Back"
    //             // disabled={this.state.stepToShow === 0}
    //             disableTouchRipple={true}
    //             disableFocusRipple={true}
    //             onClick={this.reverseStepper}/*this.handlePrev*/
    //         />
    //     );
    // }
    
    // VERIFICATION CODE

    // handleVerification = () => {
    //     this.props.verifyEmailCode(userId);
    // }

    getVerificationStep = () => (
        <VerificationStep 
            label="Verify Account"
            handleClose={this.handleCloseDialog}
            stepperControls={this.stepperControls}
            resetErrors={this.resetErrors}
            resetBookingDialog={this.resetBookingDialog}
            user={this.props.user} 
        />
    );

    setFinalStep = (finalStep) => {
        this.setState({
            finalStep: finalStep
        });
    }

    render() {
        const { title, handleClose, open, user } = this.props;
        
        const { currentDialog } = this.state;

          return (
            <div>
                {
                    <Dialog
                        title={title}
                        modal={true}
                        open={open}
                        autoScrollBodyContent={true}
                    >
                        <div style={{ marginTop: -10, marginBottom: 10 }}>
                            { this.getVerificationStep(handleClose) }
                        </div>
                    </Dialog>
                }
            </div>
          );
    }
  }

  const mapStateToProps = ({auth, dialog, client}) => {
    // console.log('%cSERVER ERROR @ MSTP','color: greenyellow');
    // console.log(auth.serverError);
    return {
        clientData: client.clientData,
        currentDialog: dialog.current,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        errorData: auth.serverError,
        passwordData: auth.passwordData,
        user: auth.authData,
        userEmail: (auth.authData) ? auth.authData.email : null,
        userId: (auth.authData) ? auth.authData.id : null,
    };
  }

  export default connect(mapStateToProps, actions)(ActivationDialog);

  /*
  
  title
  altActionText
  mainActionText
  open 
  handleClose
  
  */


// WEBPACK FOOTER //
// ./src/js/components/Dialog/ActivationDialog.jsx